export function showDropdownMenu($trigger) {
  $trigger.addClass('open');
  if (window.featureFlags?.A_18022_add_popover_to_legacy_elements) {
    const node = $trigger.find('> .dropdown-menu')[0];
    if (!node) return;
    // If the node is already open, then we do not need to do anything.
    if (node.matches(':popover-open')) return;

    const { top, bottom, left, right } = node.getBoundingClientRect();
    const newStyle = {};

    // Use a single horizontal positioning direction. If the node has a class of `.pull-left` or `.pull-right`, then we use that class to determine the horizontal positioning.
    if (node.classList.contains('pull-left')) {
      newStyle.left = `${left}px`;
    } else if (node.classList.contains('pull-right')) {
      newStyle.right = `${window.innerWidth - right}px`;
    } else {
      left < 0
        ? (newStyle.right = `${right}px`)
        : (newStyle.left = `${left}px`);
    }

    // Use a vertical positioning direction.
    top < 0 ? (newStyle.bottom = `${bottom}px`) : (newStyle.top = `${top}px`);

    if (!node.hasAttribute('popover')) node.setAttribute('popover', 'manual');

    if (node.matches(':popover-open')) node.hidePopover();

    Object.assign(node.style, newStyle);

    // Technically this should not be necessary, but Safari has a bug where the popover does not show in the proper position if we do not wait a tick.
    setTimeout(() => {
      if (node.isConnected) {
        node.showPopover();
      }
    }, 0);
  }
}

function hidePopoverAndResetPosition(node) {
  if (node.hidePopover && typeof node.hidePopover === 'function') {
    node.hidePopover();
    // reset the position of the popover
    Object.assign(node.style, {
      top: '',
      left: '',
      right: '',
      bottom: '',
    });
  }
}

export function closeDropdownMenu($trigger) {
  $trigger.removeClass('open');
  if (window.featureFlags?.A_18022_add_popover_to_legacy_elements) {
    const node = $trigger.find('> .dropdown-menu')[0];
    if (!node) return;
    try {
      if (node.matches(':popover-open')) {
        hidePopoverAndResetPosition(node);
      }
    } catch (error) {
      // Browser doesn't support :popover-open pseudo-class, try to hide anyway
      hidePopoverAndResetPosition(node);
    }
  }
}
